// Adddress common fields
const email =
  '<a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#111;&#102;&#102;&#105;&#99;&#101;&#64;&#104;&#101;&#121;&#103;&#117;&#121;&#115;&#46;&#105;&#111;">&#111;&#102;&#102;&#105;&#99;&#101;&#64;&#104;&#101;&#121;&#103;&#117;&#121;&#115;&#46;&#105;&#111;</a>'
const street = 'Kosynierów 44'
const city = '41-219 Sosnowiec'
const address = `${street}\n${city}`
const NIP = 'NIP: 6443529837'
const REGON = 'REGON: 368029292'
const KRS = 'KRS: 0000696545'
const phone = '+48 721 680 759'

const enContent = {
  common: { backToTop: 'go to the top' },
  navigation: {
    about: 'O nas',
    projects: 'Projekty',
    career: 'Kariera',
    contact: 'Kontakt',
  },
  footer: {
    email,
    companyInfo: {
      street,
      city,
      NIP,
      REGON,
      KRS,
    },
    privacyLink: {
      label: 'Polityka prywatności',
      to: '/privacy-policy/',
    },
  },
  pages: {
    home: {
      sections: {
        header: {
          headline: 'Digital marketing\ni strony internetowe\nktóre',
          headlineEnd: 'wywołują uśmiech',
          image: require('../images/home/headerImage.webp'),
          imageMobile: require('../images/home/headerImageMobile.webp'),
          imageAlt: 'Uśmiechnięci pracownicy',
          button01: {
            label: 'Dołącz do nas!',
            to: '/career/',
          },
          button02: {
            label: 'Kontakt',
            to: '/contact/',
          },
        },
        circles: {
          headline: 'Odezwij się do nas, zbudujmy coś z uśmiechem!',
          text: 'Proces tworzenia strony internetowej sprawia, że jesteś niezadowolony?',
          circle01: {
            text: 'Strony internetowe\n które twoi klienci pokochają',
          },
          circle02: {
            text: 'Kampanie digitalowe pomogą\n pozyskać nowych klientów',
          },
          circle03: {
            text: 'Twoja marka zabłyśnie\n dzięki naszym animacjom',
          },
        },
        cases: {
          headline: 'Zadbaliśmy o uśmiech tysiące razy:',

          button: {
            label: 'sprawdź nasze portfolio',
            to: '/projects',
          },
          case01: require('../images/home/case01.webp'),
          alt01: 'Nasz projekt - David und Martin',
          case02: require('../images/home/case02.webp'),
          alt02: 'Nasz projekt - Franz Eberhofer',
          case03: require('../images/home/case03.webp'),
          alt03: 'Nasz projekt - ipox',
          case04: require('../images/home/case04.webp'),
          alt04: 'Nasz projekt - Franz Eberhofer',
          case05: require('../images/home/case05.webp'),
          alt05: 'Nasz projekt - Fournell',
          case06: require('../images/home/case06.webp'),
          alt06: 'Nasz projekt - Digital Design',
        },
        cards: {
          card01: {
            headline: 'Kod oparty na najnowszych technologiach',
            text: 'Uwielbiamy stawać się coraz lepsi. W naszych projektach chętnie stosujemy najnowsze rozwiązania, co sprawia, że stale poszerzamy horyzonty w&nbsp;zakresie rozwiązań technologicznych.',
          },
          card02: {
            headline: 'Profesjonalne podejście do tworzenia stron',
            text: 'Wierzymy, że naprawdę dobre strony internetowe powstają tylko wtedy gdy tworzymy je zespołowo. Z&nbsp;tego powodu UX, UI, Motion-Design i&nbsp;development nie są odrębnymi działami.',
          },
          card03: {
            headline: 'Łączymy markę i wyniki poprzez kampanie display',
            text: 'Specjalizujemy się w kampaniach display, które sprzedają produkty oraz świetnie wyglądają. To&nbsp;podejście idealnie łączy wydajność oraz wizerunek marki. Dzięki nam możesz mieć jedno i&nbsp;drugie.',
          },
        },
        team: {
          headline: 'Poznaj nasz zespół',
          text: 'HeyGuys to więcej niż firma, to zespół ludzi, którzy dzielą się swoim doświadczeniem oraz wkładają pasję w realizowane projekty. Praca to nie tylko codzienne wyzwania i&nbsp;motywacja, to&nbsp;przede wszystkim świetna zabawa i&nbsp;inspiracja. Tworzymy przyjazną atmosferę, w&nbsp;której dobrze się czujemy.',
          button: {
            label: 'o nas!',
            to: '/about',
          },
          image01: require('../images/home/team01.webp'),
          alt01: 'nasz zespół',
          image02: require('../images/home/team02.webp'),
          alt02: 'nasze zespołowe selfie',
        },
        jobs: {
          headline: 'Dołącz do nas!',
          text: 'Obecnie szukamy:',
          jobButton01: {
            label: 'Junior Frontend Developer',
            to: '/career/junior-frontend-developer/',
          },
          jobButton02: {
            label: 'Student - wsparcie w tworzeniu banerów',
            to: '/career/student-banner-development-support/',
          },
          smallButton: { label: 'kariera', to: '/career/' },
        },
      },
    },

    about: {
      sections: {
        subheader: {
          headline: 'Wyjątkowe miejsce&nbsp;tworzą<br>niezwykłe osoby',
          smile: true,
        },
        teamGallery: {
          lastItem: {
            label: 'Może ty?',
            to: '/career/',
            button: 'kariera',
          },
          imageAlt: 'jeden z nas',
          galleryData: [
            {
              image: require('../images/about/team01.webp'),
              name: 'Agnieszka Irzykowska',
              role: 'Frontend Developer',
            },
            {
              image: require('../images/about/team02.webp'),
              name: 'Robert Gontarczyk',
              role: 'Head of office',
            },
            {
              image: require('../images/about/lukasz.jpg'),
              name: 'Łukasz Pawela',
              role: 'Frontend Developer',
            },
            {
              image: require('../images/about/natalia-g.jpg'),
              name: 'Natalia Grzesik',
              role: 'Digital Designer',
            },
            {
              image: require('../images/about/team05.webp'),
              name: 'Marek Służałek',
              role: 'Senior Frontend Developer',
            },
            {
              image: require('../images/about/team09.webp'),
              name: 'Joanna Gontarczyk',
              role: 'Office Manager',
            },
            {
              image: require('../images/about/team10.webp'),
              name: 'Uli Hattenberger & Dr David Hanisch',
              role: 'Management',
            },
            {
              image: require('../images/about/kasia.jpg'),
              name: 'Katarzyna Breczko',
              role: 'Creative Director',
            },
            {
              image: require('../images/about/team15.webp'),
              name: 'Barbara Knopek',
              role: 'Digital Designer',
            },
            {
              image: require('../images/about/basia.jpg'),
              name: 'Barbara Koźbiał',
              role: 'Motion Designer',
            },
            {
              image: require('../images/about/team13.webp'),
              name: 'Szymon Piątkowski',
              role: 'Frontend Developer',
            },
            {
              image: require('../images/about/mg-p4.jpg'),
              name: 'Mateusz Grek',
              role: 'Frontend Developer',
            },
            
          ],
        },
        events: {
          text: 'eventy',
          image01: require('../images/about/image06.webp'),
          alt01: 'pięciolecie - zdjęcie zespołu',
          image02: require('../images/about/image07.webp'),
          alt02: 'zespół w namiocie na Octoberfest',
          image03: require('../images/about/image08.webp'),
          alt03: 'pięciolecie - impreza',
          image04: require('../images/about/image09.webp'),
          alt04: 'zespół w centrum Monachium',
          image05: require('../images/about/image10.webp'),
          alt05: 'event w Karpaczu',
        },
        teamGalleryAfterWork: {
          text: 'po pracy',
          image01: require('../images/about/image01.webp'),
          alt01: 'firmowy gril',
          image02: require('../images/about/image02.webp'),
          alt02: 'wyjście firmowe',
          image03: require('../images/about/image03.webp'),
          alt03: 'spędzanie czasu w Katowicach',
          image04: require('../images/about/image04.webp'),
          alt04: 'spędzanie czasu w Dąbrowie Górniczej',
          image05: require('../images/about/image05.webp'),
          alt05: 'uśmiechnięty zespół',
        },
      },
    },
    projects: {
      sections: {
        subheader: {
          headline: 'Nasze realizacje',
          smile: true,
        },
        projects: {
          text: 'portfolio',
          addnotation:
            'Projekt zrealizowany przy współpracy z agencją <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger GMBH</a>',
          projectsData: [
            {
              headline: 'Strona internetowa dla agencji reklamowej David+Martin',
              text: 'Na stronie David+Martin króluje video. Agencja, która współpracuje z klientami z różnych branż, słynie z niebywałej kreatywności. Dzięki użyciu nieszablonowych elementów front-endowych, zyskaliśmy najwyższej jakości odtwarzanie oraz odpowiednią prędkość.',
              button: {
                label: 'zobacz więcej',
                href: 'https://davidundmartin.com/en/',
              },
              image01: require('../images/projects/dum.webp'),
              image02: require('../images/projects/dum_2.webp'),
              alt01: 'Strona przygotowana dla David+Martin',
              alt02: 'David+Martin Landing Page',
            },
            {
              headline: 'Strona internetowa dla firmy konsultingowej T60',
              text: 'T60 oznacza profesjonalizm, doświadczenie i wiedzę. Strona internetowa odzwierciedla kulturę firmy oraz jej podejście do realizowanych spraw. Rzetelnie oraz bezpośrednio, w taki sposób pomagają klientom z różnych branż osiągnąć ich cele.',
              button: {
                label: 'Zobacz sam',
                href: 'https://t60.com/',
              },
              image01: require('../images/projects/t60.webp'),
              image02: require('../images/projects/t60_2.webp'),
              alt01: 'Strona przygotowana dla T60',
              alt02: 'T60 Website Landing Page',
            },
            {
              headline: 'Strona internetowa dla Schmitts Katze',
              text: 'Strona, która stawia banery w centrum uwagi oraz pokazuje możliwości designu: od znaczników aż po animacje. Rezultatem jest bardzo indywidualna i&nbsp;silnie nastawiona na design witryna internetowa, która pokazuje możliwości kampanii display.',
              button: {
                label: 'Spójrz tutaj',
                href: 'https://schmitts-katze.de/',
              },
              image01: require('../images/projects/image05.webp'),
              image02: require('../images/projects/image06.webp'),
              alt01: 'Schmitts Katze Landing Page',
              alt02: 'Schmitts Katze - naklejki',
            },
            {
              headline: 'Strona internetowa e-magazynu Citro\u00EBnist',
              text: 'Po raz pierwszy magazyn Citro\u00EBnist przeniósł się do świata online. Niekonwencjonalny projekt oraz innowacyjność to cechy wyróżniające stronę internetową. To interaktywne i angażujące źródło informacji o pojazdach. Na stronie znajdziesz między innymi: nowinki technologiczne, nowe modele Citroëna, oferty specjalne, konkursy i nie tylko.',
              button: {
                label: 'zobacz więcej',
                href: 'https://citroenist-mag.ch/de/',
              },
              image01: require('../images/projects/citroenist.webp'),
              image02: require('../images/projects/citroenist_2.webp'),
              alt01: 'e-magazine Citro\u00EBnist Website Overview',
              alt02: 'e-magazine Citro\u00EBnist Website Landing Page',
            },
            {
              headline: 'Strona internetowa dla firmy z branży nieruchomości Triebwerk M\u00FCnchen',
              text: 'Firma Triebwerk M\u00FCnchen, mieszcząca się w dawnym warsztacie napraw kolejowych, oferuje niecodzienne usługi wynajmu w Monachium. Bogata historia tego miejsca oraz “jedyne w swoim rodzaju” nieruchomości zostały ukazane na stronie internetowej, łącząc przy tym tradycję oraz nowoczesność życia w samym centrum Monachium.',
              button: {
                label: 'Zobacz sam',
                href: 'https://triebwerk-munchen.de/',
              },
              image01: require('../images/projects/triebwerk.webp'),
              image02: require('../images/projects/triebwerk_2.webp'),
              alt01: 'Triebwerk M\u00FCnchen Landing Page',
              alt02: 'Triebwerk M\u00FCnchen Website Overview',
            },
            {
              headline: 'Strona internetowa dla producenta drewna Holzhaus Fabrik',
              text: 'Drewno to zrównoważony surowiec, który idealnie nadaje się do budowania wysokiej jakości domów. Z myślą o przyszłości Holzhaus Fabrik tworzy drewniane budynki. Wyszukany, a przy tym funkcjonalny styl idealnie prezentuje historię firmy oraz gamę produktów.',
              button: {
                label: 'Spójrz tutaj',
                href: 'https://holzhausfabrik.com/',
              },
              image01: require('../images/projects/fhe.webp'),
              image02: require('../images/projects/fhe_2.webp'),
              alt01: 'Holzhaus Fabrik Website Overview',
              alt02: 'Holzhaus Fabrik Website Landing Page',
            },
            {
              headline: 'Strona internetowa dla firmy konsultingowej FTI Andersch',
              text: 'Głównym tematem strony internetowej FTI Andersch są wyzwania zmieniające się w szanse. Dzięki dynamicznym animacjom, użytkownicy już od samego początku mogą doświadczyć potencjału, jaki dają zmiany.',
              button: {
                label: 'Zobacz sam',
                href: 'https://www.fti-andersch.com/',
              },
              image01: require('../images/projects/fti.webp'),
              image02: require('../images/projects/fti_2.webp'),
              alt01: 'FTI Andersch Landing Page',
              alt02: 'FTI Andersch Website Overview',
            },
            {
              headline: 'Relaunch dla Fournell',
              text: 'Strona internetowa, która zaczyna się od iskry, która staje się motywem przewodnim. To nie lada wyzwanie do zrealizowania, by dowolnie przeciągać i&nbsp;upuszczać moduły, tak jak zażyczył sobie tego klient. Efekt jest wart tego!',
              button: {
                label: 'zobacz więcej',
                href: 'https://fournell.de/',
              },
              image01: require('../images/projects/image07.webp'),
              image02: require('../images/projects/image08.webp'),
              alt01: 'Fournell Landing Page',
              alt02: 'Strona stworzona dla Fournell',
            },
            {
              headline: 'Fanpage dla Franz Eberhofer',
              text: 'Cyfrowy dom dla fanów kultowej postaci z&nbsp;Bawarii, Franza Eberhofera. Sprzedaje on nie tylko filmy i&nbsp;książki, ale przenosi nas do jego świata: od jego ulubionej knajpy aż po kuchnię jego babci.',
              button: {
                label: 'Poznaj go lepiej',
                href: 'https://franz-eberhofer.de/',
              },
              image01: require('../images/projects/image03.webp'),
              image02: require('../images/projects/image04.webp'),
              alt01: 'Franz Eberhofer Website Overview',
              alt02: 'Franz Eberhofer i jego pies',
            },
          ],
        },
        joinUs: {
          text: 'dołącz!',
          headline: 'Stwórzmy razem coś wspaniałego!',
          button: {
            label: 'kariera',
            to: '/career/',
          },
        },
      },
    },
    career: {
      sections: {
        subheader: {
          headline: 'Powitamy Cię z uśmiechem',
          headlineMobile: '',
          button: {
            label: 'dołącz do nas',
            to: '#mail-teaser',
          },
          lineWithCircle: true,
          smile: true,
        },
        cards: {
          text: 'wartości',
          cardsData: [
            {
              headline: 'Nowoczesność',
              text: 'Podejmujemy nowe wyzwania i&nbsp;ciągle się uczymy. Jesteśmy otwarci na nowe technologie.',
            },
            {
              headline: 'Rozwój',
              text: 'Nie stoimy w miejscu. Wszystko zmienia się u nas bardzo dynamicznie. Wesprzemy Cię w&nbsp;rozwoju.',
            },
            {
              headline: 'Zespołowość',
              text: 'Pracując nad codziennymi zadaniami zawsze wspieramy się i&nbsp;możemy na siebie liczyć. Każdy pracownik jest traktowany na&nbsp;równi.',
            },
            {
              headline: 'Domowość',
              text: 'Kawa, muzyka, ciepła herbatka, kapcie. Z&nbsp;nami poczujesz się jak w domu.',
            },
            {
              headline: 'Otwartość',
              text: 'Każda opinia ma znaczenie, jesteśmy otwarci na nowe pomysły! Jesteśmy bezpośredni i&nbsp;szczerzy.',
            },
            {
              headline: 'Uśmiech',
              text: 'Pozytywne nastawienie przyświeca nam każdego dnia!',
            },
          ],
        },
        jobList: {
          headline: 'Obecnie szukamy:',
          jobs: [
            'Junior Frontend Developer',
            'Student - wsparcie w tworzeniu banerów',
          ],
        },
        officeGallery: {
          text: 'teamwork',
          image01: require('../images/career/image01.webp'),
          alt01: 'gry zespołowe',
          image02: require('../images/career/image02.webp'),
          alt02: 'gry zespołowe - 2',
          image03: require('../images/career/image03.webp'),
          alt03: 'integracja w biurze',
          image04: require('../images/career/image04.webp'),
          alt04: 'zdjęcie zespołu',
          image05: require('../images/career/image05.webp'),
          alt05: 'zdjęcie z drona',
        },
        form: {
          headline:
            'Ta oferta jest dla ciebie?\nSkontaktuj się z nami Jesteśmy otwarci na nowe osoby',
          fields: [
            {
              id: 1,
              name: 'name',
              placeholder: 'Imie',
              type: 'text',
              required: true,
            },
            {
              id: 2,
              name: 'email',
              placeholder: 'Email',
              type: 'email',
              required: true,
            },
            {
              id: 3,
              name: 'message',
              placeholder: 'Wiadomość',
              type: 'textarea',
              required: true,
            },
          ],
          button: 'Wyślij',
        },
      },
      subpages: {
        juniorFrontendDeveloper: {
          sections: {
            subheader: {
              headline: 'Junior Frontend Developer',
              description: {
                column01:
                  'Obecnie poszukujemy osób na stanowisko junior frontend developer. Twoją pasją jest tworzenie statycznych stron oraz tych opartych na WordPressie. Razem sprawimy, że uśmiech pojawi się na twarzach naszych klientów.',
                column02:
                  'Chętnie uczysz się nowych rzeczy oraz lubisz współpracować z programistami i&nbsp;projektantami? Nie spoczniesz, dopóki wszystkie szczegóły na stronie internetowej nie będą wyglądać i&nbsp;działać tak, jak należy? W takim razie jesteśmy zespołem właśnie dla Ciebie.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'Co oferujemy',
                list: [
                  'Dobra atmosfera oraz zespół ludzi, który wspiera się wzajemnie - chętnie pomożemy Ci z nowymi wyzwaniami',
                  'Szeroki zakres projektów, od małych kampanii reklamowych, aż po duże projekty stron internetowych, co daje Ci możliwość prowadzenie własnych projektów już od pierwszego dnia pracy',
                  'Atmosfera w duchu „spróbujmy to zrobić”, w której dobre pomysły są zawsze mile widziane',
                  'Stała umowa o pracę i dobre wynagrodzenie',
                  'Szkolenia w godzinach pracy z obszarów, które są dla Ciebie nowe',
                  'Cykliczne obiady firmowe oraz coroczne imprezy firmowe',
                ],
              },
              requirements: {
                headline: 'Kogo szukamy',
                list: [
                  'Dobrze odnajdujesz się w pracy zespołowej, uwielbiasz kodowanie i masz już jakieś doświadczenie w tej dziedzinie. Pasja znaczy dla nas więcej niż dyplom.',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i&nbsp;<a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. Porozumiewanie się w języku angielskim nie powinno być dla Ciebie problemem. Jeśli Twój angielski nie jest jeszcze tak dobry, jakbyś sobie tego życzył. To żaden problem, możemy wesprzeć Cię kursami, tak byś poprawił jego znajomość.',
                ],
              },
            },
          },
        },
        frontendDeveloper: {
          sections: {
            subheader: {
              headline: 'Frontend Developer',
              description: {
                column01:
                  'Obecnie poszukujemy osób na stanowisko frontend developer. Twoją pasją jest tworzenie statycznych stron oraz tych opartych na WordPressie. Razem sprawimy, że uśmiech pojawi się na twarzach naszych klientów.',
                column02:
                  'Chętnie uczysz się nowych rzeczy oraz lubisz współpracować z programistami i projektantami? Nie spoczniesz, dopóki wszystkie szczegóły na stronie internetowej nie będą wyglądać i&nbsp;działać tak, jak należy? W takim razie jesteśmy zespołem właśnie dla Ciebie.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'Co oferujemy',
                list: [
                  'Dobra atmosfera oraz zespół ludzi, który wspiera się wzajemnie - chętnie pomożemy Ci z nowymi wyzwaniami',
                  'Szeroki zakres projektów, od małych kampanii reklamowych, aż po duże projekty stron internetowych, co daje Ci możliwość prowadzenie własnych projektów już od pierwszego dnia pracy',
                  'Atmosfera w duchu „spróbujmy to zrobić”, w której dobre pomysły są zawsze mile widziane',
                  'Stała umowa o pracę i dobre wynagrodzenie',
                  'Szkolenia w godzinach pracy z obszarów, które są dla Ciebie nowe',
                  'Cykliczne obiady firmowe oraz coroczne imprezy firmow',
                ],
              },
              requirements: {
                headline: 'Kogo szukamy',
                list: [
                  'Dobrze odnajdujesz się w pracy zespołowej, uwielbiasz kodowanie i masz już jakieś doświadczenie w tej dziedzinie. Pasja znaczy dla nas więcej niż dyplom.',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i&nbsp;<a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. Porozumiewanie się w języku angielskim nie powinno być dla Ciebie problemem. Jeśli Twój angielski nie jest jeszcze tak dobry, jakbyś sobie tego życzył. To żaden problem, możemy wesprzeć Cię kursami, tak byś poprawił jego znajomość.',
                ],
              },
            },
          },
        },
        motionDesigner: {
          sections: {
            subheader: {
              headline: 'Motion Designer',
              description: {
                column01:
                  'Obecnie poszukujemy motion designera, który specjalizuje się w&nbsp;animacjach na potrzeby mediów społecznościowych, kampanii cyfrowych oraz stron internetowych.',
                column02:
                  'Lubisz współpracować z programistami oraz projektantami i&nbsp;nie spoczniesz, dopóki wszystkie drobiazgi nie będą wyglądały tak jak trzeba? W takim razie jesteśmy zespołem właśnie dla Ciebie.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'Co oferujemy',
                list: [
                  'Różne modele współpracy – B2B, umowa o pracę, umowa zlecenie',
                  'Elastyczne godziny pracy + możliwość pracy zdalnej',
                  'Zatrudnienie w pełnym wymiarze',
                  'Brak koniczności wyjazdów służbowych',
                  'Budżet szkoleniowy dla wszystkich pracowników',
                  'Mały zespół z międzynarodowymi projektami',
                  'Bezpłatny parking obok biura oraz jeden z największych klubów fitness w okolicy',
                  'Pyszna kawa',
                ],
              },
              requirements: {
                headline: 'Kogo szukamy',
                list: [
                  'Posiadasz bardzo dobrą znajomość programów Adobe After Effects i&nbsp;Adobe Photoshop',
                  'Masz doświadczenie w tworzeniu animacji',
                  'Jesteś kreatywny/a i posiadasz pasję do projektowania',
                  'Lubisz pracę w zespole',
                  'Mile widziane: Doświadczenie w pracy z Blender lub Cinema4D',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i&nbsp;<a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. Porozumiewanie się w języku angielskim nie powinno być dla Ciebie problemem. Jeśli Twój angielski nie jest jeszcze tak dobry, jakbyś sobie tego życzył. To żaden problem, możemy wesprzeć Cię kursami, tak byś poprawił jego znajomość.',
                ],
              },
            },
          },
        },
        juniorDigitalDesigner: {
          sections: {
            subheader: {
              headline: 'Junior Digital Designer',
              description: {
                column01:
                  'Obecnie poszukujemy junior digital designera. Razem będziemy tworzyć animacje, wideo oraz banery.',
                column02:
                  'Lubisz współpracować z programistami oraz projektantami i nie spoczniesz, dopóki wszystkie drobiazgi nie będą wyglądały tak jak trzeba? W takim razie jesteśmy zespołem właśnie dla Ciebie.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'Co oferujemy',
                list: [
                  'Różne modele współpracy – B2B, umowa o pracę, umowa zlecenie',
                  'Elastyczne godziny pracy + możliwość pracy zdalnej',
                  'Zatrudnienie w pełnym wymiarze',
                  'Brak koniczności wyjazdów służbowych',
                  'Budżet szkoleniowy dla wszystkich pracowników',
                  'Mały zespół z międzynarodowymi projektami',
                  'Bezpłatny parking obok biura oraz jeden z największych klubów fitness w okolicy',
                  'Pyszna kawa',
                ],
              },
              requirements: {
                headline: 'Kogo szukamy',
                list: [
                  'Znajomość Adobe Photoshop',
                  'Chęć nauki HTML / CSS',
                  'Jesteś kreatywny/a i posiadasz pasję do projektowania',
                  'Lubisz pracę w zespole',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i&nbsp;<a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. Porozumiewanie się w języku angielskim nie powinno być dla Ciebie problemem. Jeśli Twój angielski nie jest jeszcze tak dobry, jakbyś sobie tego życzył. To żaden problem, możemy wesprzeć Cię kursami, tak byś poprawił jego znajomość.',
                ],
              },
            },
          },
        },
        seniorUIDesigner: {
          sections: {
            subheader: {
              headline: 'Senior UI Designer',
              description: {
                column01:
                  'Cześć, poszukujemy doświadczonego UI Designera. Jako członek naszego zespołu będziesz tworzyć projekty, które wspierają branding, angażują użytkowników oraz wywołują emocje.',
                column02:
                  ' Będziesz pracować w zespole z developerami i motion designerami, aby w pełni wykorzystać interaktywne możliwości technologii webowych.',
              },
              arrow: true,
            },
            offerDetails: {
              requirements: {
                headline: 'Co oferujemy',
                list: [
                  'Możliwość rozwoju i kształtowania małej, ale rosnącej agencji od strony kreatywnej',
                  'Projekty, w które jesteś zaangażowany od pierwszego pomysłu do wdrożenia',
                  'Przyjazną atmosferę pracy',
                  'Różne modele współpracy - B2B, umowa o pracę lub umowa zlecenie',
                  'Elastyczne godziny pracy + możliwość pracy zdalnej',
                  'Zatrudnienie w pełnym wymiarze godzin',
                  'Budżet na szkolenia',
                  'Pyszną kawe w biurze',
                  'Brak konieczności odbywania podróży służbowych',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>',
                ],
              },
              offer: {
                headline: 'Czego oczekujemy',
                list: [
                  '4+ lat doświadczenia w projektowaniu stron internetowych w agencji cyfrowej lub na podobnym stanowisku (poparte portfolio z projektami komercyjnymi)',
                  'Bardzo dobre umiejętności w zakresie UI',
                  'Bardzo dobre umiejętności komunikacyjne i umiejętność pracy w zespole',
                  'Zdolności do organizowania swojej pracy i angażowania młodszych kolegów',
                  'Znajomość aktualnych trendów w projektowaniu stron',
                  'Pełne entuzjazmu podejście do klienta, projektowania i możliwości cyfrowych',
                  'Bardzo dobra znajomość programu Figma',
                  'Krytyczne myślenie',
                  'Proces projektowania skoncentrowany na użytkowniku',
                  'Dbałość o szczegóły',
                  'Płynny angielski w mowie i piśmie',
                ],
                headline02: 'Co będzie mile widziane',
                list02: [
                  'Doświadczenie w projektowaniu identyfikacji wizualnych',
                  'Doświadczenie w animacji',
                  'Dobre zrozumienie UX i umiejętność tworzenia intuicyjnych ścieżek użytkownika',
                  'Dobra obsługa programów tekstowych i prezentacyjnych (Word i PowerPoint)',
                ],
              },
            },
          },
        },
        digitalCreativeDirector: {
          sections: {
            subheader: {
              headline: 'Digital Creative Director',
              description: {
                column01:
                  'Cześć, poszukujemy doświadczonego Dyrektora Kreatywnego. Jako członek naszego zespołu będziesz tworzyć projekty, które wspierają branding, angażują użytkowników oraz wywołują emocje.',
                column02:
                  'Będziesz pracować w zespole z developerami i motion designerami, aby w pełni wykorzystać interaktywne możliwości technologii webowych.',
              },
              arrow: true,
            },
            offerDetails: {
              requirements: {
                headline: 'Co oferujemy',
                list: [
                  'Możliwość rozwoju i kształtowania małej, ale rosnącej agencji od strony kreatywnej',
                  'Projekty, w które jesteś zaangażowany od pierwszego pomysłu do wprowadzenia na rynek',
                  'Szansa na bliską współpracę z naszym wewnętrznym zespołem frontendowym w celu osiągnięcia wspólnego celu, jakim jest stworzenie niesamowitych i przyjemnych w użyciu stron internetowych',
                  'Otwartą atmosferę, zespół zaangażowanych i zmotywowanych kolegów',
                  'Profesjonalną hierarchię bez walki o tytuły',
                  'Różne modele współpracy - B2B, umowa o pracę lub umowa zlecenie',
                  'Elastyczne godziny pracy + możliwość pracy zdalnej',
                  'Zatrudnienie w pełnym wymiarze godzin',
                  'Budżet na szkolenia',
                  'Pyszna kawa w biurze',
                  'Brak konieczności odbywania podróży służbowych',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>',
                ],
              },
              offer: {
                headline: 'Czego oczekujemy',
                list: [
                  'Pełnego entuzjazmu podejścia do klienta, projektowania i możliwości cyfrowych',
                  'Dobrej znajomości aktualnych trendów, nowych technologii',
                  'Co najmniej 5 lat profesjonalnego doświadczenia kreatywnego w dziedzinie kreacji i projektowania cyfrowego, w tym projektowania stron internetowych, motion designu i / lub kampanii cyfrowych',
                  'Dobrego organizowania swojej pracy i angażowania młodszych kolegów (umiejętność pracowania nad wieloma projektami  jednocześnie)',
                  'Tworzenia mocnych koncepcji, silnych umiejętności UX/UI, jak również zorganizowany i niezależny sposób pracy',
                  'Samodzielności, kreatywności, pasji tworzenia i radość z pracy w zespole',
                  'Krytycznego myślenia, projektowania z myślą o użytkowniku i dbałości o szczegóły',
                  'Mentalności "Can-do" i orientacja na rozwiązania',
                  'Pewnego korzystanie z kluczowych narzędzi, takich jak Figma i Adobe Cloud Apps',
                  'Płynnej znajomość języka angielskiego, zarówno w mowie jak i piśmie',
                ],
                headline02: 'Co należy do twoich obowiązków',
                list02: [
                  'Rozwijanie cyfrowego (re-)brandingu - od kreatywnej koncepcji do efektu finalnego',
                  'Opracowywanie innowacyjnych i efektywnych koncepcji reklam cyfrowych, które przesuwają granice możliwości technicznych i kreatywnych',
                  'Definiowanie zasad projektowania, tworzenie moodboardów, storyboardów, layoutów i projektów dla różnych znanych marek',
                  'Tworzenie projektów, które wspierają branding, są przyjemne w użytkowaniu oraz wywołują emocje',
                  'Praca w zespole z programistami i motion designerami, aby w pełni wykorzystać interaktywne możliwości technologii internetowych',
                  'Kreatywna odpowiedzialność za współpracę z kolegami z różnych dziedzin, takich jak copywriting, sztuka, motion design, rozwój, strategia i zarządzanie projektem',
                  'Czuwanie nad całym procesem wdrażania koncepcji, od pierwszego pomysłu do efektu końcowego',
                  'Pomoc w zrozumieniu oczekiwań i wymagań naszych klientów oraz przełożenie ich na koncepcje i projekty',
                  'Szybkie i pragmatyczne tworzenie pomysłów',
                  'Czynny udział w rozwoju działu kreatywnego oraz agencji. Wychodzenie z pomysłami, otwartość na dyskusję',
                ],
              },
            },
          },
        },
        studentHTML5BannerSpecialist: {
          sections: {
            subheader: {
              headline: 'Student - wsparcie w tworzeniu banerów',
              description: {
                column01:
                  'Obecnie poszukujemy studenta, który będzie wsparciem przy tworzeniu banerów HTML5. Razem będziemy tworzyć zaawansowane animacje w banerach dla dużych kampanii reklamowych.',
                column02:
                  'Lubisz współpracować z programistami oraz projektantami i nie spoczniesz, dopóki wszystkie drobiazgi nie będą wyglądały tak jak trzeba? W takim razie jesteśmy zespołem właśnie dla Ciebie.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'Co oferujemy',
                list: [
                  'Elastyczne godziny pracy, które ułatwią Ci pogodzenie pracy ze studiami',
                  'Praca w niepełnym wymiarze godzin (pół etatu)',
                  'Mały zespół z międzynarodowymi projektami',
                  'Bezpłatny parking obok biura oraz jeden z największych klubów fitness w okolicy',
                  'Pyszna kawa',
                ],
              },
              requirements: {
                headline: 'Mile widziane',
                list: [
                  'Podstawowa Znajomość Adobe Photoshop',
                  'Chęć nauki HTML / CSS',
                  'Lubisz pracę w zespole',
                  'Ściśle współpracujemy z firmami <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> i&nbsp;<a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>.',
                ],
              },
            },
            recruitmentSteps: {
              headline: 'Proces rekrutacji:',
              circle01: {
                text: '1. Prześlij nam swoje CV lub link do profilu na LinkedIn',
              },
              circle02: {
                text: '2. Rozmowa telefoniczna z managerem biura ',
              },
              circle03: {
                text: '3. Rozmowa z liderem działu',
              },
              circle04: {
                text: '4. Witamy w zespole!',
              },
            },
          },
        },
        shared: {
          sections: {
            recruitmentSteps: {
              headline: 'Proces rekrutacji:',
              circle01: {
                text: '1. Prześlij nam swoje CV lub link do profilu na LinkedIn',
              },
              circle02: {
                text: '2. Poznajmy się podczas rozmowy telefonicznej',
              },
              circle03: {
                text: '3. Sprawdzamy Twoje umiejętności u nas w biurze',
              },
              circle04: {
                text: '4. Witamy w zespole!',
              },
            },
            offerSummary: {
              headline:
                'Uśmiechnąłeś się?\n Więc wyślij nam swoje CV!\n Masz jakieś pytania?\n Napisz do nas lub zadzwoń.',
              email,
              image: require('../images/career/team01.webp'),
              alt: 'Zespół w Katowicach',
            },
          },
        },
      },
    },
    privacy: {
      sections: {
        subheader: {
          headline: 'Polityka prywatności',
        },
        content:
          '<div><h2><span>POLITYKA PRYWATNOŚCI I COOKIES</span></h2> </div><div><p>Niniejszy Serwis nie zbiera w sposób automatyczny żadnych informacji, z wyjątkiem informacji zawartych w plikach cookies. Poniższa Polityka plików Cookies (ciasteczek) określa zasady zapisywania i uzyskiwania dostępu do danych na Urządzeniach Użytkowników korzystających z Serwisu do celów świadczenia usług drogą elektroniczną przez Administratora Serwisu.</p></div><div><h2><span>§ 1 DEFINICJE</span></h2><p>1. Serwis&nbsp;- serwis internetowy działający pod adresem&nbsp;www.heyguys.io</p> <br><p>2. Serwis zewnętrzny&nbsp;- serwis internetowe partnerów, usługodawców lub usługobiorców Administratora</p> <br><p>3. Administrator&nbsp;- firma&nbsp;HEYGUYS Sp. z o.o., prowadząca działalność pod adresem:&nbsp;ul. Kosynierów 44, 41-219 Sosnowiec, o nadanym numerze identyfikacji podatkowej (NIP):&nbsp;6443529837,o nadanym numerze REGON:&nbsp;368029292, zarejestrowana w&nbsp;SĄDZIE REJONOWYM KATOWICE WSCHÓD W KATOWICACH, VIII WYDZIAŁ GOSPODARCZY KRAJOWEGO REJESTRU SĄDOWEGO&nbsp;pod numerem KRS:&nbsp;0000696545, świadcząca usługi drogą elektroniczną za pośrednictwem Serwisu oraz przechowująca i uzyskująca dostęp do informacji w urządzeniach Użytkownika</p><br><p>4. Użytkownik&nbsp;- osoba fizyczna, dla której Administrator świadczy usługi drogą elektroniczną za pośrednictwem Serwisu.</p><br><p>5. Urządzenie&nbsp;- elektroniczne urządzenie wraz z oprogramowaniem, za pośrednictwem, którego Użytkownik uzyskuje dostęp do Serwisu</p><br><p>6. Cookies (ciasteczka)&nbsp;- dane tekstowe gromadzone w formie plików zamieszczanych na Urządzeniu Użytkownika</p></div><div><h2><span>§ 2 RODZAJE COOKIES</span></h2><p>1. Cookies wewnętrzne&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez system teleinformatyczny Serwisu</p><br><p>2. Cookies zewnętrzne&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez systemy teleinformatyczne Serwisów zewnętrznych</p><br><p>3. Cookies sesyjne&nbsp;- pliki zamieszczane iodczytywane z Urządzenia Użytkownika przez Serwis&nbsp;lub Serwisy zewnętrzne&nbsp;podczas jednej sesji danego Urządzenia. Po zakończeniu sesji pliki są usuwane z Urządzenia Użytkownika.</p> <br><p>4. Cookies trwałe&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez Serwis&nbsp;lub Serwisy zewnętrzne&nbsp;do momentu ich ręcznego usunięcia. Pliki nie są usuwane automatycznie po zakończeniu sesji Urządzenia chyba że konfiguracja Urządzenia Użytkownika jest ustawiona na tryb usuwanie plików Cookie po zakończeniu sesji Urządzenia.</p></div><div><h2><span>§ 3 BEZPIECZEŃSTWO</span></h2><p>1. Mechanizmy składowania i odczytu&nbsp;- Mechanizmy składowania i odczytu Cookies nie pozwalają na pobierania jakichkolwiek danych osobowych ani żadnych informacji poufnych z Urządzenia Użytkownika.Przeniesienie na Urządzenie Użytkownika wirusów, koni trojańskich oraz innych robaków jest praktycznie niemożliwe</p> <br><p>2. Cookie wewnętrzne&nbsp;- zastosowane przez Administratora Cookie wewnętrzne są bezpieczne dla Urządzeń Użytkowników</p><br><p>3. Cookie zewnętrzne&nbsp;- za bezpieczeństwo plików Cookie pochodzących od partnerów Serwisu Administrator nie ponosi odpowiedzialności. Lista partnerów zamieszczona jest w dalszej części Polityki Cookie.</p></div><div><h2><span>§ 4 CELE DO KTÓRYCH WYKORZYSTYWANE SĄ PLIKI COOKIE</span></h2> <p>1. Usprawnienie i ułatwienie dostępu do Serwisu&nbsp;Administrator może przechowywać w plikach Cookie informacje o preferencjach i ustawieniach użytkownika dotyczących Serwisu aby usprawnić, polepszyć i przyśpieszyć świadczenie usług w ramach Serwisu.</p> <br><p>2. Dane statystyczne&nbsp;- Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystuje pliki Cookie do zbierania i przetwarzania danych statystycznych, takich jak np. statystyki odwiedzin, statystyki Urządzeń Użytkowników czy statystyki zachowań użytkowników. Dane te zbierane są w celu analizy i ulepszania Serwisu.</p> <br><p>3. Serwowanie usług multimedialnych&nbsp;-Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystuje pliki Cookie do serwowania Użytkownikom usług multimedialnych.</p> <br><p>4. Usługi społecznościowe&nbsp;- Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystują pliki Cookie do wsparcia usług społecznościowych.</p></div><div><h2><span>§ 5 SERWISY ZEWNĘTRZNE</span></h2><p>Administrator współpracuje z następującymi serwisami zewnętrznymi, które mogą zamieszczać pliki Cookie na Urządzeniach Użytkownika: Google Analytics, Google+, AddThis, Youtube.</p> </div><div><h2><span>§ 6 MOŻLIWOŚCI OKREŚLANIA WARUNKÓW PRZECHOWYWANIA I UZYSKIWANIA DOSTĘPU NA URZĄDZENIACH UŻYTKOWNIKA PRZEZ SERWIS&nbsp;I SERWISY ZEWNĘTRZNE</span></h2><p>1. Użytkownik może w dowolnym momencie, samodzielnie zmienić ustawienia dotyczące zapisywania, usuwania oraz dostępu do danych zapisanych plików Cookies.</p><br><p>2. Użytkownik może w dowolnym momencie usunąć wszelkie zapisane do tej pory pliki Cookie korzystając z narzędzi Urządzenia Użytkownika, za pośrednictwem którego Użytkownik korzysta z usług Serwisu.</p></div><div><h2><span>§ 7 WYMAGANIA SERWISU</span></h2><p>1. Ograniczenie zapisu i dostępu do plików Cookie na Urządzeniu Użytkownika może spowodować nieprawidłowe działanie niektórych funkcji Serwisu.</p><br><p>2. Administrator nie ponosi żadnej odpowiedzialności za nieprawidłowo działające funkcje Serwisu w przypadku, gdy Użytkownik ograniczy w jakikolwiek sposób możliwość zapisywania i odczytu plików Cookie.</p></div><div><h2><span>§ 8 ZMIANY W POLITYCE COOKIE</span></h2><p>1. Administrator zastrzega sobie prawo do dowolnej zmiany niniejszej Polityki Cookie bez konieczności informowania o tym użytkowników.</p><br><p>2. Wprowadzone zmiany w Polityce Cookie zawsze będą publikowane na tej stronie.</p> <br><p>3. Wprowadzone zmiany wchodzą w życie w dniu publikacji Polityki Cookie.</p> </div>',
      },
    },
    contact: {
      headline: 'Zapraszamy do kontaktu!',
      email,
      address,
      phone,
      hours: 'Pon-Pt: 9-17',
      companyInfo: {
        NIP,
        REGON,
        KRS,
      },
    },
  },
}
export default enContent
